// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"723e88f6","453":"90d27115","556":"ff5ab0d0"}[chunkId] + ".chunk.js";
};